import { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import MyStudentLayout from "../../../layouts/Student/MyStudentLayout";
import './../../../assets/css/student/MentorRequestsPage.css';


// ─── SVG ICON SYSTEM ───────────────────────────────────────────────────────────

const Icons = {
  Pending: () => (
    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="1.8"/>
      <path d="M12 7v5l3 3" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  ),
  Accepted: () => (
    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M9 12l2.25 2.25L15 9" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
      <circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="1.8"/>
    </svg>
  ),
  Rejected: () => (
    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="1.8"/>
      <path d="M15 9l-6 6M9 9l6 6" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round"/>
    </svg>
  ),
  Active: () => (
    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M13 2L3 14h9l-1 8 10-12h-9l1-8z" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  ),
  Star: ({ filled }) => (
    <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" className={filled ? "star-filled" : "star-empty"}>
      <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"
        fill={filled ? "currentColor" : "none"} stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  ),
  Search: () => (
    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="11" cy="11" r="7" stroke="currentColor" strokeWidth="1.8"/>
      <path d="M21 21l-4.35-4.35" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round"/>
    </svg>
  ),
  Filter: () => (
    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M22 3H2l8 9.46V19l4 2v-8.54L22 3z" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  ),
  Close: () => (
    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M18 6L6 18M6 6l12 12" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round"/>
    </svg>
  ),
  ChevronRight: () => (
    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M9 18l6-6-6-6" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  ),
  ChevronLeft: () => (
    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M15 18l-6-6 6-6" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  ),
  Sparkle: () => (
    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M12 2v4M12 18v4M4.93 4.93l2.83 2.83M16.24 16.24l2.83 2.83M2 12h4M18 12h4M4.93 19.07l2.83-2.83M16.24 7.76l2.83-2.83" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round"/>
    </svg>
  ),
  User: () => (
    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="12" cy="8" r="4" stroke="currentColor" strokeWidth="1.8"/>
      <path d="M4 20c0-4 3.58-7 8-7s8 3 8 7" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round"/>
    </svg>
  ),
  Message: () => (
    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M21 15a2 2 0 01-2 2H7l-4 4V5a2 2 0 012-2h14a2 2 0 012 2v10z" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  ),
  Clock: () => (
    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="1.8"/>
      <path d="M12 7v5l3 2" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round"/>
    </svg>
  ),
  Students: () => (
    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round"/>
      <circle cx="9" cy="7" r="4" stroke="currentColor" strokeWidth="1.8"/>
      <path d="M23 21v-2a4 4 0 00-3-3.87M16 3.13a4 4 0 010 7.75" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round"/>
    </svg>
  ),
  Link: () => (
    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M10 13a5 5 0 007.54.54l3-3a5 5 0 00-7.07-7.07l-1.72 1.71" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M14 11a5 5 0 00-7.54-.54l-3 3a5 5 0 007.07 7.07l1.71-1.71" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  ),
  Check: () => (
    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M20 6L9 17l-5-5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  ),
  Cancel: () => (
    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="1.8"/>
      <path d="M15 9l-6 6M9 9l6 6" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round"/>
    </svg>
  ),
  Eye: () => (
    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" stroke="currentColor" strokeWidth="1.8"/>
      <circle cx="12" cy="12" r="3" stroke="currentColor" strokeWidth="1.8"/>
    </svg>
  ),
  Timeline: () => (
    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <line x1="12" y1="2" x2="12" y2="22" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round"/>
      <circle cx="12" cy="6" r="3" fill="currentColor"/>
      <circle cx="12" cy="12" r="3" fill="currentColor"/>
      <circle cx="12" cy="18" r="3" fill="currentColor"/>
    </svg>
  ),
  Github: () => (
    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M9 19c-5 1.5-5-2.5-7-3m14 6v-3.87a3.37 3.37 0 00-.94-2.61c3.14-.35 6.44-1.54 6.44-7A5.44 5.44 0 0020 4.77 5.07 5.07 0 0019.91 1S18.73.65 16 2.48a13.38 13.38 0 00-7 0C6.27.65 5.09 1 5.09 1A5.07 5.07 0 005 4.77a5.44 5.44 0 00-1.5 3.78c0 5.42 3.3 6.61 6.44 7A3.37 3.37 0 009 18.13V22" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  ),
  Discover: () => (
    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="1.8"/>
      <polygon points="16.24 7.76 14.12 14.12 7.76 16.24 9.88 9.88 16.24 7.76" fill="currentColor"/>
    </svg>
  ),
  Inbox: () => (
    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <polyline points="22 12 16 12 14 15 10 15 8 12 2 12" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M5.45 5.11L2 12v6a2 2 0 002 2h16a2 2 0 002-2v-6l-3.45-6.89A2 2 0 0016.76 4H7.24a2 2 0 00-1.79 1.11z" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  ),
  Flag: () => (
    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M4 15s1-1 4-1 5 2 8 2 4-1 4-1V3s-1 1-4 1-5-2-8-2-4 1-4 1z" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
      <line x1="4" y1="22" x2="4" y2="15" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round"/>
    </svg>
  ),
};

// ─── MOCK DATA ──────────────────────────────────────────────────────────────────

const MENTORS = [
  {
    id: 1,
    name: "Sarah Chen",
    initials: "SC",
    title: "Senior Frontend Engineer @ Stripe",
    expertise: ["React", "TypeScript", "System Design"],
    rating: 4.9,
    students: 47,
    available: true,
    responseTime: "< 2 hrs",
    matchScore: 94,
    bio: "8 years building scalable UIs at Stripe and Airbnb. Passionate about teaching React architecture and performance optimization.",
    successRate: 96,
    color: "#7C3AED",
  },
  {
    id: 2,
    name: "Marcus Rivera",
    initials: "MR",
    title: "ML Engineer @ Google DeepMind",
    expertise: ["AI/ML", "Python", "LLMs"],
    rating: 4.8,
    students: 62,
    available: true,
    responseTime: "< 4 hrs",
    matchScore: 87,
    bio: "Researcher turned engineer. Specialized in making AI accessible to developers at all levels.",
    successRate: 94,
    color: "#059669",
  },
  {
    id: 3,
    name: "Priya Nair",
    initials: "PN",
    title: "Staff Backend Engineer @ Notion",
    expertise: ["Node.js", "Databases", "API Design"],
    rating: 4.7,
    students: 38,
    available: false,
    responseTime: "< 24 hrs",
    matchScore: 78,
    bio: "Built Notion's sync engine. Expert in distributed systems and high-throughput APIs.",
    successRate: 91,
    color: "#D97706",
  },
  {
    id: 4,
    name: "James Liu",
    initials: "JL",
    title: "Engineering Manager @ Linear",
    expertise: ["Interview Prep", "Career Growth", "Leadership"],
    rating: 5.0,
    students: 89,
    available: true,
    responseTime: "< 6 hrs",
    matchScore: 82,
    bio: "Interviewed 500+ engineers. Helps candidates crack FAANG at all levels.",
    successRate: 98,
    color: "#DC2626",
  },
  {
    id: 5,
    name: "Aisha Johnson",
    initials: "AJ",
    title: "DevRel Lead @ Vercel",
    expertise: ["Next.js", "Portfolio", "Content"],
    rating: 4.6,
    students: 104,
    available: true,
    responseTime: "< 12 hrs",
    matchScore: 71,
    bio: "Helped 100+ developers land their first job through portfolio mentoring and personal branding.",
    successRate: 89,
    color: "#0891B2",
  },
  {
    id: 6,
    name: "Tom Eriksen",
    initials: "TE",
    title: "Principal Engineer @ Shopify",
    expertise: ["React Native", "Mobile", "Performance"],
    rating: 4.8,
    students: 55,
    available: false,
    responseTime: "< 8 hrs",
    matchScore: 68,
    bio: "Led Shopify's mobile platform team. Expert in cross-platform performance and native integrations.",
    successRate: 93,
    color: "#7C3AED",
  },
];

const MY_REQUESTS = [
  {
    id: "req_001",
    mentorName: "Sarah Chen",
    mentorInitials: "SC",
    mentorColor: "#7C3AED",
    goal: "React Architecture",
    status: "accepted",
    submittedAt: "2025-01-08T10:30:00Z",
    updatedAt: "2025-01-09T14:20:00Z",
    level: "Intermediate",
    commitment: "1 month",
    timeline: [
      { stage: "Requested", time: "Jan 8, 10:30 AM", done: true, note: "Request submitted successfully" },
      { stage: "Viewed", time: "Jan 8, 3:45 PM", done: true, note: "Sarah viewed your request" },
      { stage: "Accepted", time: "Jan 9, 2:20 PM", done: true, note: "Sarah accepted! Welcome to the mentorship." },
      { stage: "Active Mentorship", time: "Ongoing", done: false, note: null },
    ],
  },
  {
    id: "req_002",
    mentorName: "Marcus Rivera",
    mentorInitials: "MR",
    mentorColor: "#059669",
    goal: "AI/ML Foundations",
    status: "pending",
    submittedAt: "2025-01-10T08:15:00Z",
    updatedAt: "2025-01-10T08:15:00Z",
    level: "Beginner",
    commitment: "3 months",
    timeline: [
      { stage: "Requested", time: "Jan 10, 8:15 AM", done: true, note: "Request submitted successfully" },
      { stage: "Viewed", time: null, done: false, note: null },
      { stage: "Accepted", time: null, done: false, note: null },
      { stage: "Active Mentorship", time: null, done: false, note: null },
    ],
  },
  {
    id: "req_003",
    mentorName: "James Liu",
    mentorInitials: "JL",
    mentorColor: "#DC2626",
    goal: "FAANG Interview Prep",
    status: "rejected",
    submittedAt: "2024-12-20T16:00:00Z",
    updatedAt: "2024-12-22T09:30:00Z",
    level: "Advanced",
    commitment: "1 week",
    timeline: [
      { stage: "Requested", time: "Dec 20, 4:00 PM", done: true, note: "Request submitted" },
      { stage: "Viewed", time: "Dec 21, 11:00 AM", done: true, note: "James viewed your request" },
      { stage: "Rejected", time: "Dec 22, 9:30 AM", done: true, note: "Mentor at full capacity. Try again next month." },
      { stage: "Active Mentorship", time: null, done: false, note: null },
    ],
  },
];

const GOALS = ["React & Frontend", "AI / Machine Learning", "Backend & APIs", "Interview Prep", "Portfolio Building", "Career Transition", "System Design", "Custom Goal"];
const LEVELS = ["Beginner", "Intermediate", "Advanced"];
const COMMITMENTS = ["1 week", "1 month", "3 months"];

// ─── HELPER COMPONENTS ──────────────────────────────────────────────────────────

function Avatar({ initials, color, size = 48 }) {
  return (
    <div className="mentor-avatar" style={{ width: size, height: size, background: `${color}18`, color, fontSize: size * 0.33, borderColor: `${color}30` }}>
      {initials}
    </div>
  );
}

function StarRating({ rating }) {
  return (
    <div className="star-rating">
      {[1, 2, 3, 4, 5].map(i => (
        <span key={i} className={i <= Math.round(rating) ? "star-on" : "star-off"}>
          <Icons.Star filled={i <= Math.round(rating)} />
        </span>
      ))}
      <span className="rating-value">{rating.toFixed(1)}</span>
    </div>
  );
}

function StatusBadge({ status }) {
  const map = {
    pending: { label: "Pending", cls: "badge-pending" },
    accepted: { label: "Accepted", cls: "badge-accepted" },
    rejected: { label: "Rejected", cls: "badge-rejected" },
    expired: { label: "Expired", cls: "badge-expired" },
    active: { label: "Active", cls: "badge-active" },
  };
  const { label, cls } = map[status] || map.pending;
  return <span className={`status-badge ${cls}`}>{label}</span>;
}

function MatchBadge({ score }) {
  const color = score >= 90 ? "#7C3AED" : score >= 80 ? "#059669" : "#D97706";
  return (
    <div className="match-badge" style={{ color, background: `${color}12`, border: `1px solid ${color}30` }}>
      <Icons.Sparkle />
      <span>{score}% match</span>
    </div>
  );
}

// ─── KPI WIDGET ─────────────────────────────────────────────────────────────────

function MentorKPIWidget({ label, value, icon: Icon, accent }) {
  return (
    <div className="kpi-card" style={{ "--accent": accent }}>
      <div className="kpi-icon-wrap">
        <Icon />
      </div>
      <div className="kpi-info">
        <div className="kpi-value">{value}</div>
        <div className="kpi-label">{label}</div>
      </div>
      <div className="kpi-glow" />
    </div>
  );
}

// ─── MENTOR CARD ─────────────────────────────────────────────────────────────────

function MentorCard({ mentor, onRequest, onViewProfile }) {
  return (
    <div className="mentor-card" onClick={() => onViewProfile(mentor)}>
      <div className="mentor-card-header">
        <Avatar initials={mentor.initials} color={mentor.color} size={52} />
        <div className="mentor-card-meta">
          <div className="mentor-name">{mentor.name}</div>
          <div className="mentor-title">{mentor.title}</div>
        </div>
        <MatchBadge score={mentor.matchScore} />
      </div>

      <div className="mentor-tags">
        {mentor.expertise.map(tag => (
          <span key={tag} className="expertise-tag">{tag}</span>
        ))}
      </div>

      <StarRating rating={mentor.rating} />

      <div className="mentor-stats">
        <div className="mentor-stat">
          <span className="stat-icon"><Icons.Students /></span>
          <span>{mentor.students} students</span>
        </div>
        <div className="mentor-stat">
          <span className="stat-icon"><Icons.Clock /></span>
          <span>{mentor.responseTime}</span>
        </div>
      </div>

      <div className="mentor-card-footer">
        <div className={`availability-dot ${mentor.available ? "avail-on" : "avail-off"}`}>
          <span className={mentor.available ? "pulse" : ""} />
          {mentor.available ? "Available" : "Unavailable"}
        </div>
        <div className="mentor-card-actions" onClick={e => e.stopPropagation()}>
          <button className="btn-ghost" onClick={() => onViewProfile(mentor)}>Profile</button>
          <button className="btn-primary" onClick={() => onRequest(mentor)}>Request</button>
        </div>
      </div>
    </div>
  );
}

// ─── REQUEST CARD ─────────────────────────────────────────────────────────────────

function RequestCard({ request, onViewTracker, onCancel }) {
  const dt = new Date(request.submittedAt);
  const dateStr = dt.toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" });

  return (
    <div className="request-card">
      <div className="request-card-left">
        <Avatar initials={request.mentorInitials} color={request.mentorColor} size={44} />
      </div>
      <div className="request-card-body">
        <div className="request-card-top">
          <div>
            <div className="request-mentor-name">{request.mentorName}</div>
            <div className="request-goal">{request.goal}</div>
          </div>
          <StatusBadge status={request.status} />
        </div>
        <div className="request-meta">
          <span>{request.level}</span>
          <span className="dot-sep">·</span>
          <span>{request.commitment}</span>
          <span className="dot-sep">·</span>
          <span>{dateStr}</span>
        </div>
        <div className="request-actions">
          <button className="btn-ghost-sm" onClick={() => onViewTracker(request)}>
            <Icons.Eye /> Track
          </button>
          {request.status === "accepted" && (
            <button className="btn-ghost-sm btn-green">
              <Icons.Message /> Message
            </button>
          )}
          {request.status === "pending" && (
            <button className="btn-ghost-sm btn-red" onClick={() => onCancel(request.id)}>
              <Icons.Cancel /> Cancel
            </button>
          )}
        </div>
      </div>
    </div>
  );
}

// ─── REQUEST TRACKER TIMELINE ──────────────────────────────────────────────────

function RequestTrackerTimeline({ request, onClose }) {
  if (!request) return null;
  return (
    <div className="tracker-panel">
      <div className="tracker-header">
        <div>
          <div className="tracker-title">Request Tracker</div>
          <div className="tracker-subtitle">{request.mentorName} · {request.goal}</div>
        </div>
        <button className="icon-btn" onClick={onClose}><Icons.Close /></button>
      </div>

      <div className="timeline">
        {request.timeline.map((item, i) => {
          const isLast = i === request.timeline.length - 1;
          const isRejected = item.stage === "Rejected";
          return (
            <div key={i} className={`timeline-item ${item.done ? "tl-done" : "tl-pending"} ${isRejected ? "tl-rejected" : ""}`}>
              <div className="tl-connector-wrap">
                <div className={`tl-dot ${item.done ? (isRejected ? "dot-red" : "dot-green") : "dot-gray"}`}>
                  {item.done ? (isRejected ? <Icons.Rejected /> : <Icons.Check />) : <span className="dot-inner" />}
                </div>
                {!isLast && <div className={`tl-line ${item.done ? "line-done" : ""}`} />}
              </div>
              <div className="tl-content">
                <div className="tl-stage">{item.stage}</div>
                {item.time && <div className="tl-time">{item.time}</div>}
                {item.note && <div className="tl-note">{item.note}</div>}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

// ─── MENTOR DETAIL PANEL ──────────────────────────────────────────────────────

function MentorDetailPanel({ mentor, onClose, onRequest }) {
  if (!mentor) return null;
  return (
    <>
      <div className="panel-backdrop" onClick={onClose} />
      <div className="detail-panel slide-in">
        <div className="panel-header">
          <button className="icon-btn" onClick={onClose}><Icons.Close /></button>
        </div>

        <div className="panel-profile">
          <Avatar initials={mentor.initials} color={mentor.color} size={72} />
          <div className="panel-name">{mentor.name}</div>
          <div className="panel-title-text">{mentor.title}</div>
          <div className="panel-tags">
            {mentor.expertise.map(t => <span key={t} className="expertise-tag">{t}</span>)}
          </div>
          <StarRating rating={mentor.rating} />
        </div>

        <div className="panel-stats-grid">
          <div className="panel-stat-block">
            <div className="psb-val">{mentor.successRate}%</div>
            <div className="psb-label">Success Rate</div>
          </div>
          <div className="panel-stat-block">
            <div className="psb-val">{mentor.students}</div>
            <div className="psb-label">Students Mentored</div>
          </div>
          <div className="panel-stat-block">
            <div className="psb-val">{mentor.responseTime}</div>
            <div className="psb-label">Response Time</div>
          </div>
          <div className="panel-stat-block">
            <div className="psb-val" style={{ color: mentor.available ? "#059669" : "#DC2626" }}>
              {mentor.available ? "Open" : "Closed"}
            </div>
            <div className="psb-label">Availability</div>
          </div>
        </div>

        <div className="panel-bio">{mentor.bio}</div>

        <div className="panel-match-callout" style={{ background: `${mentor.color}10`, borderColor: `${mentor.color}25` }}>
          <Icons.Sparkle />
          <div>
            <div className="pmc-title" style={{ color: mentor.color }}>{mentor.matchScore}% match with your roadmap</div>
            <div className="pmc-hint">Adding a portfolio link increases your acceptance rate by 2x</div>
          </div>
        </div>

        <div className="panel-actions">
          <button className="btn-primary panel-cta" onClick={() => { onClose(); onRequest(mentor); }}>
            Request Mentorship
          </button>
          <button className="btn-ghost panel-secondary">
            <Icons.Flag /> Report
          </button>
        </div>
      </div>
    </>
  );
}

// ─── MULTI-STEP REQUEST MODAL ──────────────────────────────────────────────────

function MentorRequestModal({ mentor, onClose, onSubmit }) {
  const [step, setStep] = useState(0);
  const [form, setForm] = useState({
    goal: "",
    customGoal: "",
    level: "",
    objective: "",
    commitment: "",
    portfolio: "",
    github: "",
  });

  const totalSteps = 5;
  const progress = ((step + 1) / (totalSteps + 1)) * 100;

  const canNext = () => {
    if (step === 0) return form.goal !== "";
    if (step === 1) return form.level !== "";
    if (step === 2) return form.objective.trim().length > 20;
    if (step === 3) return form.commitment !== "";
    return true;
  };

  const handleSubmit = () => {
    onSubmit({ ...form, mentorId: mentor.id });
    onClose();
  };

  const steps = ["Select Goal", "Your Level", "Objective", "Time Commitment", "Attachments"];

  return (
    <div className="modal-backdrop" onClick={onClose}>
      <div className="modal-box" onClick={e => e.stopPropagation()}>
        {/* Header */}
        <div className="modal-header">
          <div className="modal-mentor-info">
            <Avatar initials={mentor.initials} color={mentor.color} size={36} />
            <div>
              <div className="modal-mentor-name">{mentor.name}</div>
              <div className="modal-mentor-role">Mentorship Request</div>
            </div>
          </div>
          <button className="icon-btn" onClick={onClose}><Icons.Close /></button>
        </div>

        {/* Progress */}
        <div className="modal-progress">
          <div className="progress-bar">
            <div className="progress-fill" style={{ width: `${progress}%` }} />
          </div>
          <div className="step-labels">
            {steps.map((s, i) => (
              <span key={i} className={`step-label ${i === step ? "step-active" : i < step ? "step-done" : ""}`}>{s}</span>
            ))}
          </div>
        </div>

        {/* Step Content */}
        <div className="modal-content">
          {step === 0 && (
            <div className="step-pane">
              <div className="step-title">What do you want to learn?</div>
              <div className="goal-grid">
                {GOALS.map(g => (
                  <button
                    key={g}
                    className={`goal-chip ${form.goal === g ? "chip-active" : ""}`}
                    onClick={() => setForm(f => ({ ...f, goal: g, customGoal: g === "Custom Goal" ? f.customGoal : "" }))}
                  >
                    {g}
                  </button>
                ))}
              </div>
              {form.goal === "Custom Goal" && (
                <input
                  className="text-input mt-12"
                  placeholder="Describe your custom goal..."
                  value={form.customGoal}
                  onChange={e => setForm(f => ({ ...f, customGoal: e.target.value }))}
                />
              )}
            </div>
          )}

          {step === 1 && (
            <div className="step-pane">
              <div className="step-title">What is your current level?</div>
              <div className="level-options">
                {LEVELS.map(l => (
                  <button
                    key={l}
                    className={`level-card ${form.level === l ? "level-active" : ""}`}
                    onClick={() => setForm(f => ({ ...f, level: l }))}
                  >
                    <div className="level-name">{l}</div>
                    <div className="level-desc">
                      {l === "Beginner" && "Just starting out, learning fundamentals"}
                      {l === "Intermediate" && "Comfortable with basics, building projects"}
                      {l === "Advanced" && "Professional experience, seeking mastery"}
                    </div>
                  </button>
                ))}
              </div>
            </div>
          )}

          {step === 2 && (
            <div className="step-pane">
              <div className="step-title">What do you want to achieve?</div>
              <textarea
                className="text-area"
                placeholder="Describe your goals, challenges, and what success looks like for you after this mentorship..."
                value={form.objective}
                onChange={e => setForm(f => ({ ...f, objective: e.target.value }))}
                rows={6}
              />
              <div className={`char-count ${form.objective.length < 20 ? "char-warn" : "char-ok"}`}>
                {form.objective.length} chars {form.objective.length < 20 ? `(min 20)` : ""}
              </div>
            </div>
          )}

          {step === 3 && (
            <div className="step-pane">
              <div className="step-title">How long do you need mentorship?</div>
              <div className="commit-options">
                {COMMITMENTS.map(c => (
                  <button
                    key={c}
                    className={`commit-card ${form.commitment === c ? "commit-active" : ""}`}
                    onClick={() => setForm(f => ({ ...f, commitment: c }))}
                  >
                    {c}
                  </button>
                ))}
              </div>
            </div>
          )}

          {step === 4 && (
            <div className="step-pane">
              <div className="step-title">Add your links <span className="optional-tag">Optional</span></div>
              <div className="link-inputs">
                <div className="link-input-wrap">
                  <span className="link-icon"><Icons.Link /></span>
                  <input className="text-input-icon" placeholder="Portfolio URL (e.g., yoursite.com)" value={form.portfolio} onChange={e => setForm(f => ({ ...f, portfolio: e.target.value }))} />
                </div>
                <div className="link-input-wrap">
                  <span className="link-icon"><Icons.Github /></span>
                  <input className="text-input-icon" placeholder="GitHub profile URL" value={form.github} onChange={e => setForm(f => ({ ...f, github: e.target.value }))} />
                </div>
              </div>
              <div className="ai-hint">
                <Icons.Sparkle />
                <span>Mentors with portfolio links respond <strong>2x faster</strong> and accept <strong>40% more</strong> requests.</span>
              </div>

              {/* Summary */}
              <div className="request-summary">
                <div className="summary-row"><span>Goal</span><span>{form.goal === "Custom Goal" ? form.customGoal : form.goal}</span></div>
                <div className="summary-row"><span>Level</span><span>{form.level}</span></div>
                <div className="summary-row"><span>Duration</span><span>{form.commitment}</span></div>
              </div>
            </div>
          )}
        </div>

        {/* Footer */}
        <div className="modal-footer">
          <button className="btn-ghost" onClick={() => step > 0 ? setStep(s => s - 1) : onClose()}>
            {step > 0 ? <><Icons.ChevronLeft /> Back</> : "Cancel"}
          </button>
          {step < totalSteps - 1 ? (
            <button className="btn-primary" disabled={!canNext()} onClick={() => setStep(s => s + 1)}>
              Continue <Icons.ChevronRight />
            </button>
          ) : (
            <button className="btn-primary btn-submit" onClick={handleSubmit}>
              <Icons.Check /> Submit Request
            </button>
          )}
        </div>
      </div>
    </div>
  );
}

// ─── VIEW TABS ──────────────────────────────────────────────────────────────────

function ViewTabs({ active, onChange }) {
  const tabs = [
    { id: "discover", label: "Discover Mentors", icon: Icons.Discover },
    { id: "requests", label: "My Requests", icon: Icons.Inbox },
    { id: "tracker", label: "Request Tracker", icon: Icons.Timeline },
  ];
  return (
    <div className="view-tabs">
      {tabs.map(t => (
        <button key={t.id} className={`view-tab ${active === t.id ? "tab-active" : ""}`} onClick={() => onChange(t.id)}>
          <t.icon />
          {t.label}
        </button>
      ))}
    </div>
  );
}

// ─── MAIN PAGE ───────────────────────────────────────────────────────────────────

export default function MentorRequestsPage() {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState("discover");
  const [requestModal, setRequestModal] = useState(null);
  const [detailPanel, setDetailPanel] = useState(null);
  const [trackerRequest, setTrackerRequest] = useState(null);
  const [requests, setRequests] = useState(MY_REQUESTS);
  const [search, setSearch] = useState("");
  const [filterAvail, setFilterAvail] = useState(false);
  const [successToast, setSuccessToast] = useState(false);

  const kpis = [
    { label: "Pending Requests", value: requests.filter(r => r.status === "pending").length, icon: Icons.Pending, accent: "#D97706" },
    { label: "Accepted", value: requests.filter(r => r.status === "accepted").length, icon: Icons.Accepted, accent: "#059669" },
    { label: "Rejected", value: requests.filter(r => r.status === "rejected").length, icon: Icons.Rejected, accent: "#DC2626" },
    { label: "Active Mentorships", value: requests.filter(r => r.status === "accepted").length, icon: Icons.Active, accent: "#7C3AED" },
  ];

  const filteredMentors = MENTORS.filter(m => {
    const q = search.toLowerCase();
    const matchSearch = !q || m.name.toLowerCase().includes(q) || m.expertise.some(e => e.toLowerCase().includes(q));
    const matchAvail = !filterAvail || m.available;
    return matchSearch && matchAvail;
  });

  const handleSubmitRequest = (formData) => {
    const mentor = MENTORS.find(m => m.id === formData.mentorId);
    const newReq = {
      id: `req_${Date.now()}`,
      mentorName: mentor.name,
      mentorInitials: mentor.initials,
      mentorColor: mentor.color,
      goal: formData.goal === "Custom Goal" ? formData.customGoal : formData.goal,
      status: "pending",
      submittedAt: new Date().toISOString(),
      updatedAt: new Date().toISOString(),
      level: formData.level,
      commitment: formData.commitment,
      timeline: [
        { stage: "Requested", time: new Date().toLocaleString(), done: true, note: "Request submitted successfully" },
        { stage: "Viewed", time: null, done: false, note: null },
        { stage: "Accepted", time: null, done: false, note: null },
        { stage: "Active Mentorship", time: null, done: false, note: null },
      ],
    };
    setRequests(r => [newReq, ...r]);
    setSuccessToast(true);
    setTimeout(() => setSuccessToast(false), 3500);
    setActiveTab("requests");
  };

  const handleCancel = (id) => {
    setRequests(r => r.filter(req => req.id !== id));
  };

  return (
    <MyStudentLayout>
    <div className="mrp-root">
      {/* Toast */}
      {successToast && (
        <div className="toast toast-success">
          <Icons.Check /> Request submitted successfully!
        </div>
      )}

      {/* Header */}
      <div className="mrp-header">
        <div>
          <h1 className="mrp-title">Mentor Requests</h1>
          <p className="mrp-subtitle">Request mentorship from experts aligned with your learning goals</p>
        </div>
        {/* ─── AI MENTOR WIZARD BUTTON ─── */}
        <button className="btn-wizard" onClick={() => navigate('/mentor-wizard')}>
          <Icons.Sparkle />
          AI Mentor Wizard
        </button>
      </div>

      {/* KPI Strip */}
      <div className="kpi-strip">
        {kpis.map(k => <MentorKPIWidget key={k.label} {...k} />)}
      </div>

      {/* Tabs */}
      <ViewTabs active={activeTab} onChange={setActiveTab} />

      {/* ── Discover Tab ── */}
      {activeTab === "discover" && (
        <div className="tab-pane fade-in">
          <div className="discover-toolbar">
            <div className="search-wrap">
              <span className="search-icon"><Icons.Search /></span>
              <input className="search-input" placeholder="Search mentors, skills..." value={search} onChange={e => setSearch(e.target.value)} />
            </div>
            <button className={`filter-btn ${filterAvail ? "filter-active" : ""}`} onClick={() => setFilterAvail(f => !f)}>
              <Icons.Filter /> Available Only
            </button>
          </div>

          <div className="ai-insight-bar">
            <Icons.Sparkle />
            <span>AI matching active — mentors ranked by your roadmap stage, wishlist, and course progress</span>
          </div>

          <div className="mentor-grid">
            {filteredMentors.map(m => (
              <MentorCard key={m.id} mentor={m} onRequest={setRequestModal} onViewProfile={setDetailPanel} />
            ))}
            {filteredMentors.length === 0 && (
              <div className="empty-state">No mentors found for your search.</div>
            )}
          </div>
        </div>
      )}

      {/* ── My Requests Tab ── */}
      {activeTab === "requests" && (
        <div className="tab-pane fade-in">
          <div className="requests-list">
            {requests.length === 0 && (
              <div className="empty-state">No requests yet. Discover mentors to get started.</div>
            )}
            {requests.map(r => (
              <RequestCard key={r.id} request={r} onViewTracker={req => { setTrackerRequest(req); setActiveTab("tracker"); }} onCancel={handleCancel} />
            ))}
          </div>
        </div>
      )}

      {/* ── Tracker Tab ── */}
      {activeTab === "tracker" && (
        <div className="tab-pane fade-in">
          {trackerRequest ? (
            <RequestTrackerTimeline request={trackerRequest} onClose={() => setTrackerRequest(null)} />
          ) : (
            <div className="tracker-select">
              <div className="tracker-select-title">Select a request to track</div>
              <div className="requests-list">
                {requests.map(r => (
                  <RequestCard key={r.id} request={r} onViewTracker={setTrackerRequest} onCancel={handleCancel} />
                ))}
              </div>
            </div>
          )}
        </div>
      )}

      {/* Modals & Panels */}
      {requestModal && (
        <MentorRequestModal mentor={requestModal} onClose={() => setRequestModal(null)} onSubmit={handleSubmitRequest} />
      )}

      {detailPanel && (
        <MentorDetailPanel mentor={detailPanel} onClose={() => setDetailPanel(null)} onRequest={m => { setDetailPanel(null); setRequestModal(m); }} />
      )}
    </div>
    </MyStudentLayout>
  );
}